import { ReelAnimateTime } from '@/bundle/shared/components/ReelAnimateTime/ReelAnimateTime';
import { ButtonNew } from '@/components-new/ButtonNew/ButtonNew';
import { Box } from '@/components/Box/Box';
import { Typography } from '@/components/Typography/Typography';
import { useTimer } from '@/hooks/useTimer';
import { useState } from 'react';

type VerificationInProgressType = {
  phone: string;
  isLoading: boolean;
  canResend: boolean;
  onResend: () => void;
  onChangeNumber: () => void;
  resendIn: number;
  onTimerEnds: () => void;
};

export const VerificationInProgress = ({
  phone,
  isLoading,
  canResend,
  onResend,
  onChangeNumber,
  resendIn,
  onTimerEnds,
}: VerificationInProgressType) => {
  const [seed] = useState(resendIn);
  const { seconds } = useTimer(seed, onTimerEnds);
  const waiting = resendIn > 0;

  return (
    <Box display='flex' flexDirection='column' gap='20px'>
      <Typography variant='bodySmall'>
        Check your phone <strong>{phone}</strong> for a text message from TrustStamp and complete the steps. This page
        updates on its own.
      </Typography>
      <ButtonNew variant='primary' disabled={waiting || !canResend} isLoading={isLoading} onClick={onResend}>
        {waiting ? (
          <>
            Resend in &nbsp; <ReelAnimateTime seconds={seconds} />
          </>
        ) : (
          'Resend verification link'
        )}
      </ButtonNew>
      {!waiting && (
        <ButtonNew variant='secondary' onClick={onChangeNumber}>
          Use a different number
        </ButtonNew>
      )}
    </Box>
  );
};
